import React, { useState, useRef, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import { VolumeUp, VolumeOff, Audiotrack, MusicOff } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';

const AudioPlayer = ({ url }) => {
    const [isPlaying, setIsPlaying] = useState(false); // Default isPlaying to true for autoplay
    const audioRef = useRef(new Audio(url));
    audioRef.current.loop = true;
    const [retryCount, setRetryCount] = useState(0);

    const togglePlayPause = () => {
        const prevValue = isPlaying;
        setIsPlaying(!prevValue);
        if (!prevValue) {
            audioRef.current.loop = true;
            audioRef.current.play();
        } else {
            audioRef.current.pause();
        }
    };

    useEffect(() => {
        const attemptPlay = () => {
            audioRef.current.loop = true;
            audioRef.current.play().then(() => {
                setIsPlaying(true);
                console.log('Playback started successfully');
            }).catch(error => {
                console.error('Playback failed:', error);
                if (retryCount < 3) { // Limit the number of retries to 3
                    setTimeout(() => {
                        console.log(`Retrying playback attempt: ${retryCount + 1}`);
                        setRetryCount(retryCount + 1);
                        attemptPlay();
                    }, 2000); // Retry after 2 seconds
                } else {
                    setIsPlaying(false);
                }
            });
        };

        attemptPlay();

        // Cleanup function to pause audio when component unmounts
        return () => {
            audioRef.current.pause();
        };
    }, [retryCount]); // Depend on retryCount to trigger retries

    return (
        <Tooltip title="Ambient sound">
        <IconButton onClick={togglePlayPause}>
            {isPlaying ? <Audiotrack /> : <MusicOff />}
        </IconButton>
        </Tooltip>
    );
};

export default AudioPlayer;
